import axios from 'axios';
var myaxios = {};
myaxios.install = function(Vue){
    var axios_obj = axios.create({
        //中行支付接口
        baseURL: 'http://crm.51homemoney.com:9003/api',
        transformRequest: [function (data) {
            let ret = ''
            for (let it in data) {
              ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
          }],
        headers:{'Content-Type': 'application/x-www-form-urlencoded'}
    })
    // axios_obj.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
    Vue.prototype.$payhttp = axios_obj;
}
export default myaxios;


// WEBPACK FOOTER //
// ./src/assets/js/httppay.js